import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { ShareArtifactWithOrgsRequest } from './shareArtifactWithOrgs.types'

export const shareArtifactWithOrgs = async ({
  publicId,
  orgs
}: ShareArtifactWithOrgsRequest): Promise<void> => {
  await forgeApi.post(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/shares`,
    {
      orgs
    }
  )
}

export const useShareArtifactWithOrgsMutation = (
  options?: ExtendableMutationOptions<void, ShareArtifactWithOrgsRequest>
) =>
  useMutation({
    mutationFn: shareArtifactWithOrgs,
    ...options
  })
